<template>
  <button class="btn btn-outline-primary d-lg-none mb-4 rounded-0 w-50 filter-button" type="button" data-bs-toggle="collapse" data-bs-target="#filter" aria-expanded="false" aria-controls="filter">
    Filter
    <i class="fa-solid fa-angle-down text-primary float-end"></i>
    <i class="fa-solid fa-angle-up text-primary float-end"></i>
  </button>
  <div id="filter"
       class="filter-wrapper collapse d-lg-block mb-4 mb-lg-0 pe-lg-3 pe-xxl-5 pt-lg-4">
    <div class="d-flex justify-content-between pb-3">
      <span><strong>Filters</strong></span>
      <a href="javascript:void(0)"
         @click="clearFilters()"
         class="small text-dark">
        Clear filters
      </a>
    </div>
    <div class="d-flex flex-wrap filters">
      <template v-for="(filter, filterIndex) in allFields">
        <template v-for="(field, fieldIndex) in filter.fields">
          <div class="me-2 pb-2"
               v-if="field.selected && field.name != 'All'">
            <span class="badge bg-tertiary border border-secondary border-1 text-dark">
              <a class="text-dark text-decoration-none" href="javascript:void(0)"
                 role="button"
                 :aria-label="`remove ${field.name}`"
                 @click="deselectField(filterIndex, fieldIndex)">
                {{field.name}}
                <i class="fal fa-times-circle ms-2"></i>
              </a>
            </span>
          </div>
        </template>
      </template>
    </div>
    <div class="pt-3 filter-column"
         v-for="(filter, filterIndex) in allFields"
         :key="filterIndex">
      <span class="fw-bold" v-text="startCase(filter.title)"></span>
      <div>
        <div class="position-relative">
            <ul
              class="filter-list list-unstyled m-0 py-3"
              :class="[
                filterIndex == allFields.length - 1 ? 'border-0' : '',
                filterDropdowns[filterIndex].collapsed ? 'collapsed' : '',
              ]"
            >
              <li v-for="(field, fieldIndex) in filter.fields"
                  :key="fieldIndex"
                  class="d-flex justify-content-between mb-1" :class="!field.name ? 'd-none' : ''">
                <div class="form-group d-flex position-relative">
                  <input
                    type="checkbox"
                    class="form-check-inline"
                    :id="`input-${filterIndex}-${fieldIndex}`"
                    v-model="field.selected"
                    @change="updateFields(filterIndex, field)"
                  />
                  <label
                    :for="`input-${filterIndex}-${fieldIndex}`"
                    class="form-check-label fw-normal"
                  >
                    {{field.name}}
                  </label>
                  <span class="checkmark"></span>
                </div>
              </li>
            </ul>
          <button
            class="filter-list-see-more position-absolute"
            v-if="filter.fields.length > 8"
            @click="filterDropdowns[filterIndex].collapsed = !filterDropdowns[filterIndex].collapsed"
          >
            <span v-if="filterDropdowns[filterIndex].collapsed">
              See More {{ getSeeMoreTitle(filterDropdowns[filterIndex].title) }}
              <i class="fal fa-chevron-down"></i>
            </span>
            <span v-else>
              See Less {{ getSeeMoreTitle(filterDropdowns[filterIndex].title) }}
              <i class="fal fa-chevron-up"></i>
            </span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { computed, onBeforeMount, reactive } from 'vue';
  import _ from 'lodash';
  import { v4 as uuid } from 'uuid';

  export default {
    props: {
      items: {
        type: Array,
        required: true
      },
      filters: {
        type: Array,
        required: true
      }
    },
    emits: ["filteredItems", "loading"],
    setup(props, { emit }) {
      const filterId = uuid();
      const fields = reactive([]);
      const objects = reactive([]);
      const filterDropdowns = reactive(
        props.filters.map((filter, index) => {
          return {
            title: filter.Key,
            collapsed: true,
            index,
          }
        })
      );

      const getSeeMoreTitle = (title) => {
        return title.charAt(title.length - 1) === 's'
          ? title
          : `${title}s`;
      }

      const updateFields = (filterIndex, field) => {
        emit('loading', true);
        if (field.name == 'All') {
          if (field.selected) {
            for (const innerField of fields[filterIndex].fields) {
              if (innerField.name != 'All') {
                innerField.selected = false;
              }
            }
          } else {
            field.selected = true;
          }
        } else {
          fields[filterIndex].fields[0].selected = !fields[filterIndex].fields.filter(i => {
            return i.name != 'All';
          }).some(f => f.selected);
        }
      };

      const deselectField = (filterIndex, fieldIndex) => {
        fields[filterIndex].fields[fieldIndex].selected = false;
        updateFields(filterIndex, fields[filterIndex].fields[fieldIndex]);
      };

      const clearFilters = () => {
        for (const field of fields) {
          for (const innerField of field.fields) {
            innerField.selected = innerField.name == 'All';
          }
        }
      };

      const startCase = (str) => {
        return _.startCase(_.upperFirst(str));
      };

      const allFields = computed(() => {
        for (const obj of objects) {
          let allFiltersSelected = [];

          for (const field of fields) {
              field.filtersFound = 0;
              allFiltersSelected.push(...field.fields.filter(f => f.selected));
          }

          allFiltersSelected.forEach(filter => {
            obj.Organizations.forEach(organization => {
              if (
                filter.name === organization && filter.parent === 'Organization' ||
                filter.name === 'All' && filter.parent === 'Organization'
              ) {
                fields.find(f => f.title === 'Organization').filtersFound++;
              }
            });

            obj.Formats.forEach(format => {
              if (
                filter.name === format && filter.parent === 'Format' ||
                filter.name === 'All' && filter.parent === 'Format'
              ) {
                fields.find(f => f.title === 'Format').filtersFound++;
              }
            });

            obj.Topics.forEach(topic => {
              if (
                filter.name === topic && filter.parent === 'Topics' ||
                filter.name === 'All' && filter.parent === 'Topics'
              ) {
                fields.find(f => f.title === 'Topics').filtersFound++;
              }
            });

            if (
              filter.name === obj.Year && filter.parent === 'Year' ||
              filter.name === 'All' && filter.parent === 'Year'
            ) {
              fields.find(f => f.title === 'Year').filtersFound++;
            }

            if (
              filter.name === obj.Author && filter.parent === 'Author' ||
              filter.name === 'All' && filter.parent === 'Author'
            ) {
              fields.find(f => f.title === 'Author').filtersFound++;
            }
          });

          obj.Visible = fields.every(f => f.filtersFound > 0);
        }

        const visibleItems = objects.filter(f => {
          return f.Visible;
        });

        emit('filteredItems', visibleItems);

        for (const field of fields) {
          for (let i = 0; i < field.fields.length; i++) {
            if (i == 0) {
              field.fields[i].count = objects.filter(obj => {
                return !!obj[field.title] && obj.Visible;
              }).length;
            } else {
              field.fields[i].count = objects.filter(obj => {
                return !!(obj[field.title] == field.fields[i].name) && obj.Visible;
              }).length;
            }
          }
        }

        emit('loading', false);
        return fields;
      });

      onBeforeMount(() => {
        const urlParams = Object.fromEntries(new URLSearchParams(window.location.search).entries());
        const initObjs = props.items.map(i => ({
          ...i,
          Visible: true,
        }));
        const initFields = props.filters.map(f => ({
          title: f.Key.replace(/\s/g, ''),
          fields: f.Value.map(fv => ({
            name: fv,
            selected: false,
            parent: f.Key,
            count: props.items.filter(obj => {
              const realKey = _.findKey(obj, (v, k) => {
                return k.toLowerCase() === f.Key.toLowerCase();
              });
              return fv == obj[realKey];
            }).length
          }))
        }));

        for (const key of Object.keys(urlParams)) {
          const prop = initFields.find(f => f.title.toString().toLowerCase() == key.toString().toLowerCase());
          if (prop) {
            const valueArr = urlParams[key].split(',');
            for (const arrValue of valueArr) {
              const propField = prop.fields.find(pf => pf.name.toLowerCase() == arrValue.toLowerCase())
              if (propField) {
                propField.selected = true;
              }
            }
          }
        }

        for (const field of initFields) {
          const allField = {
            name: 'All',
            selected: !field.fields.some(f => f.selected),
            parent: field.title,
            count: props.items.filter(i => {
              return !!i[field.title];
            }).length
          }
          field.fields.unshift(allField);
          fields.push(field);
        }

        [].push.apply(objects, initObjs);
      });

      return {
        filterId,
        allFields,
        updateFields,
        clearFilters,
        deselectField,
        startCase,
        filterDropdowns,
        getSeeMoreTitle,
      };
    }
  }
</script>
